import { useMutation } from '../';
import { newNotificationRule } from '../mutations';

export function useNewNotificationRule() {
  const { data, isLoading, mutate } = useMutation();
  
  const run = (variables, onFinish) => {
    mutate(newNotificationRule, variables, (response) => {
      if (typeof onFinish === 'function') {
        onFinish(response.newNotificationRule.id);
      }
    });
  };

  return { data, isLoading, run };
}
